import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

import {$validateRes} from '@utils/vaildate'
import {supplier_help_category} from '@api/home'


export default new Vuex.Store({
  state: {
    // 菜单列表
    menuList: [],
    firstMenuID: '',
    menuDefaltActive: '',
  },
  getters: {

  },
  mutations: {
    SET_MENU_LIST(state, list) {
      state.menuList = list
    },
    SET_MENU_DEFALT_ACTIVE(state, val) {
      state.menuDefaltActive = String(val)
    }
  },
  actions: {
    // 获取菜单列表
    async GetMenuList({commit, state}) {
      let {data} = await supplier_help_category({
        page: 1,
        limit: 99999,
      })
      $validateRes(data)
        .then(() => {
          let menuList = data.list
          let id = null

          if(menuList[0] && !menuList[0].child_list) {
            id = menuList[0].id
          }else if(menuList[0] && menuList[0].child_list.length) {
            id = menuList[0].child_list[0].id
          }

          state.firstMenuID = id

          commit('SET_MENU_LIST', menuList)
        })
    },
    
  }
});
